import React, { Component } from "react";
import LoadingScreen from "react-loading-screen";
import { Row, Col } from "reactstrap";
import "../../styles/estilos.css";
import Page from "components/Page";
import { withRouter, Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { fetchRecuperarCarritoAccP } from "../../redux/actions/aRamoAccidentesPersonales";
import { timingSafeEqual } from "crypto";

const paso1 = "cotizacion-accidente-personal";
const paso2 = "servicios-cotizacion-accidente-personal";
const paso3 = "detalle-cotizacion-accidente-personal";
const paso4 = "detalle-cotizacion-accidente-personal";
const paso5 = "datos-facturacion";

class CotizacionAccPersonalRecuperar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      datosRecuperarCarritoAP: "",
      loading: true,
      paso: "",
      idCarrito: "",
      loading2: true
    };
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito = queryParams.get("idCarrito");

    await this.props.recuperarCarrito({
      empresa: "AIGMETROPOLITANA",
      idCarrito: idCarrito,
    });

    let paso = "";
      const pasoAct = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .pasoMayor;
      console.clear();
      console.log(this.props.datosRecuperarCarritoAccP);
      console.log(pasoAct);

      switch (pasoAct) {
        case 1:
          paso = paso1;
          break;

        case 2:
          paso = paso2;
          break;
        case 3:
          paso = paso3;
          break;
        case 4:
          paso = paso4;
          break;
        case 5:
          paso = paso5;
          break;
        default:
          paso = pasoAct;
      }

    this.setState({ idCarrito: idCarrito,paso:paso, loading:false  });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.idCarrito !== this.state.idCarrito) {
      let paso = "";
      const pasoAct = this.props.datosRecuperarCarritoAccP.recuperarCarritoAccP
        .pasoMayor;
      console.clear();
      console.log(this.props.datosRecuperarCarritoAccP);
      console.log(pasoAct);

      switch (pasoAct) {
        case 1:
          paso = paso1;
          break;

        case 2:
          paso = paso2;
          break;
        case 3:
          paso = paso3;
          break;
        case 4:
          paso = paso4;
          break;
        case 5:
          paso = paso5;
          break;
        default:
          paso = pasoAct;
      }

      this.setState({
        paso: paso,
        loading: false
      });
    }

    console.log(this.state);
  }

  render() {
    const queryParams = new URLSearchParams(this.props.location.search);

    return (
      <LoadingScreen
        loading={this.state.loading}
        bgColor="#f1f1f1"
        spinnerColor="#001871"
        textColor="#676767"
        text="Obteniendo datos..."
      >
        <Page
          title="Cotización de D O"
          breadcrumbs={[{ name: "Cotización linea financiera", active: true }]}
        >
          <Row>
            <Col lg={8} md={12} sm={12} xs={12}>
              <div className="container-step">
                <div className="wrapper-step">
                  <div className="arrow-steps clearfix-step">
                    <div className="step"> {` 1. Cotización `} </div>
                    <div className="step current"> {` 2. Resumen `} </div>
                    <div className="step"> {` 3. Confirmación `} </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              className="detalle-cotizacion-box"
            >
            {this.state.paso != "" &&
                < Redirect
                  to={this.state.paso + "?id=" + this.state.idCarrito}
                ></Redirect>
              }
            </Col>
            {/*
  
            */}
          </Row>
        </Page>
      </LoadingScreen>
    );
  }
}

const mapStateToProps = (state) => ({
  datosRecuperarCarritoAccP: state.datosRecuperarCarritoAccP,
});

const mapDispatchToProps = (dispatch) => {
  return {
    recuperarCarrito: (datos) => dispatch(fetchRecuperarCarritoAccP(datos)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CotizacionAccPersonalRecuperar)
);
